import type { IUserSessionViewModel } from "../../network/contracts/IGenericIndexViewModel";
import type { Pow3AccessRequestType } from "../../network/contracts/Pow3AccessRequestType";
import { CurrentUserType } from "../../network/contracts/CurrentUserType";

export interface IUserSessionStore {
    readonly currentUserType: CurrentUserType;
    readonly pow3AccessRequestType: Pow3AccessRequestType | null;
    readonly isGlobalAdmin: boolean;
}

export class UserSessionStore implements IUserSessionStore {
    currentUserType: CurrentUserType = CurrentUserType.Unknown;
    pow3AccessRequestType: Pow3AccessRequestType | null = null;
    isGlobalAdmin = false;

    constructor(private readonly userSessionViewModel: IUserSessionViewModel) {
        this.currentUserType = userSessionViewModel.currentUserType;
        this.pow3AccessRequestType = userSessionViewModel.accessRequestType;
        this.isGlobalAdmin = userSessionViewModel.isGlobalAdmin;
    }
}
